import { Injectable, inject, signal } from '@angular/core';
import { ErrorService } from './error.service';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private errorService = inject(ErrorService);

  // Signals for geolocation data
  private _darkMode = signal<boolean>(false);
  private _showNextTask = signal<boolean>(false);
  private storage = inject(Storage);
  /**
   * Readonly signal getter for dark mode data
   */
  darkMode = this._darkMode.asReadonly();
  showNextTask = this._showNextTask.asReadonly();
  constructor() {
  }

  async init() {
    this._darkMode.set(await this.storage.get('dark-mode'));
    if (this._darkMode()) {
      document.documentElement.classList.add('ion-palette-dark');
    }
    const showNextTask = await this.storage.get('show-next-task')
    this._showNextTask.set(showNextTask !== null ? showNextTask : false);
  }

  async setDarkMode(darkMode: boolean): Promise<void> {
    await this.storage.set('dark-mode', darkMode);
    this._darkMode.set(darkMode);
    if (darkMode) {
      document.documentElement.classList.add('ion-palette-dark');
    } else {
      document.documentElement.classList.remove('ion-palette-dark');
    }
  }

  async setShowNextTask(showNextTask: boolean): Promise<void> {
    await this.storage.set('show-next-task', showNextTask);
    this._showNextTask.set(showNextTask);
  }
}
